export const SECTION_BACKGROUND = {
  hero: {
    phone: 'var(--decorative-theme-dark)',
    tablet: 'var(--decorative-theme-dark)',
    desktop: 'black',
  },
  dealPrice: {
    phone: 'linear-gradient(270deg, #006CFD 0%, #002961 37.28%, #001C41 56.57%, #000000 100%)',
    tablet: 'linear-gradient(270deg, #006CFD 0%, #002961 37.28%, #001C41 56.57%, #000000 100%)',
    desktop: undefined,
  },
  checkDeal: {
    phone: 'linear-gradient(180deg, #006CFD 0%, #002961 37.28%, #001C41 56.57%, #000000 100%)',
    tablet: 'linear-gradient(270deg, #006CFD 0%, #002961 37.28%, #001C41 56.57%, #000000 100%)',
    desktop: 'linear-gradient(270deg, #006CFD 0%, #002961 37.28%, #001C41 56.57%, #000000 100%)',
  },
  dealFlexibility: {
    phone: 'var(--temp-vars-deep-blue)',
    tablet: 'var(--temp-vars-deep-blue)',
    desktop: 'var(--temp-vars-deep-blue)',
  },
  callMe: {
    phone: 'var(--temp-vars-deep-blue)',
    tablet: 'var(--temp-vars-deep-blue)',
    desktop: undefined,
  },
  signupForMasterClass: {
    phone: 'var(--temp-vars-deep-blue)',
    tablet: 'var(--temp-vars-deep-blue)',
    desktop: undefined,
  },
} as const;
